import {
    GET_ABOUT_COMPANY, GET_ABOUT_COMPANY_BANNER, GET_ALL_CERTIFICATES,
    GET_CE,
    GET_CERTIFICATES, GET_COMMENDATION, GET_CONTACT_US,
    GET_EXPORT, GET_GIFTS,
    GET_ISO,
    GET_MANAGEMENT,
    GET_STANDARD, POST_CONTACT_US
} from "./action_type";
import {
    SET_ABOUT_COMPANY, SET_ABOUT_COMPANY_BANNER,
    SET_CERTIFICATES,
    SET_CONTACT_US,
    SET_EXPORT,
    SET_LOADING,
    SET_MANAGEMENT
} from "./mutation_types";
import {getApi, postApi} from "../../data/ApiService";
import {SET_ERROR} from "../eventManagement/mutation_types";


export default {
    async[GET_EXPORT]({commit}){
        commit(SET_LOADING,true);
        try {
            const response = await getApi('category/203/page/1/count/1');
            const countries = await getApi('banners/11');
            console.log(response);
            commit(SET_EXPORT,{
                resource:response,
                countries:countries
            });
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },

    async[GET_CERTIFICATES]({commit},payload){
        commit(SET_LOADING,true);
        try {
            const response = await getApi(`category/${payload.id}/page/1/count/100`);
            console.log(response);
            commit(SET_CERTIFICATES,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async[GET_ALL_CERTIFICATES]({commit},payload){
        commit(SET_LOADING,true);
        try {
            let url='category/14/page/1/count/10000';
            if(payload != 0){
                url=`category/${payload}/page/1/count/10000`;
            }
            const response = await getApi(url);
            console.log(response);
            commit(SET_CERTIFICATES,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async[GET_ISO]({commit}){
        commit(SET_LOADING,true);
        try {
            const response = await getApi('category/30/page/1/count/100');
            console.log(response);
            commit(SET_CERTIFICATES,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async[GET_CE]({commit}){
        commit(SET_LOADING,true);
        try {
            const response = await getApi('category/31/page/1/count/100');
            console.log(response);
            commit(SET_CERTIFICATES,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async[GET_STANDARD]({commit}){
        commit(SET_LOADING,true);
        try {
            const response = await getApi('category/32/page/1/count/100');
            console.log(response);
            commit(SET_CERTIFICATES,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async[GET_GIFTS]({commit}){
        commit(SET_LOADING,true);
        try {
            const response = await getApi('category/33/page/1/count/100');
            console.log(response);
            commit(SET_CERTIFICATES,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async[GET_COMMENDATION]({commit}){
        commit(SET_LOADING,true);
        try {
            const response = await getApi('category/34/page/1/count/100');
            console.log(response);
            commit(SET_CERTIFICATES,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },

    async[GET_ABOUT_COMPANY]({commit}){
        commit(SET_LOADING,true);
        try {
            const response = await getApi('category/201/page/1/count/100');
            console.log(response);
            commit(SET_ABOUT_COMPANY,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },

    async[GET_ABOUT_COMPANY_BANNER]({commit}){
        commit(SET_LOADING,true);
        try {
            const response = await getApi('banners/4');
            console.log(response);
            commit(SET_ABOUT_COMPANY_BANNER,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async[GET_MANAGEMENT]({commit}){
        commit(SET_LOADING,true);
        try {
            const response = await getApi('category/202/page/1/count/1');
            console.log(response);
            commit(SET_MANAGEMENT,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    
    async getAboutUsText({commit,state}){
        commit(SET_LOADING,true);
        try {
            const response = await getApi('topic/1474');
            console.log(response);
            state.about_us_text=response.data.topic[0];
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async[GET_CONTACT_US]({commit}){
        commit(SET_LOADING,true);
        try {
            const response = await getApi('topics/19/fields');
            console.log(response);
            commit(SET_CONTACT_US,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async[POST_CONTACT_US]({commit},payload){
        // commit(SET_LOADING,true);
        try {
            const response = await postApi('topics/19',payload);
            console.log(response);
            commit(SET_CONTACT_US,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            // commit(SET_LOADING,false);
        }
    },
}